import { enGB, es, de, fr, it, nl, pl, pt, zhCN } from 'date-fns/locale';

export const DATE_PICKER_SUPPORTED_LOCALES = { en: enGB, es, de, fr, it, nl, pl, pt, zh: zhCN };
